var graphics = {
    "I3S": [
        ["臺北市", 0],
        ["臺中市", 1],
        ["基隆市", 2],
        ["臺南市", 3],
        ["高雄市", 4],
        ["新北市", 5],
        ["宜蘭市", 6],
        ["桃園市", 7],
        ["嘉義市", 8],
        ["新竹縣", 9],
        ["苗栗縣", 10],
        ["南投縣", 11],
        ["彰化縣", 12],
        ["新竹市", 13],
        ["雲林縣", 14],
        ["嘉義縣", 15],
        ["屏東縣", 16],
        ["花蓮縣", 17],
        ["臺東縣", 18],
        ["金門縣", 19],
        ["澎湖縣", 20],
        ["連江縣", 21]
    ],
    "3DTiles": [
        ["臺北市", 0],
        ["臺中市", 1],
        ["基隆市", 2],
        ["臺南市", 3],
        ["高雄市", 4],
        ["新北市", 5],
        ["宜蘭市", 6],
        ["桃園市", 7],
        ["嘉義市", 8],
        ["新竹縣", 9],
        ["苗栗縣", 10],
        ["南投縣", 11],
        ["彰化縣", 12],
        ["新竹市", 13],
        ["雲林縣", 14],
        ["嘉義縣", 15],
        ["屏東縣", 16],
        ["花蓮縣", 17],
        ["臺東縣", 18],
        ["金門縣", 19],
        ["澎湖縣", 20],
        ["連江縣", 21]
    ],
}

export default graphics;